import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "17",
  viewBox: "0 0 18 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.10108 7.36426C1.33447 7.40668 1.56525 7.42947 1.78012 7.42947H1.97358L0.985082 11.4037H6.92979C7.17117 11.4037 7.36152 11.5959 7.36152 11.8304C7.1355 14.0015 10.1447 13.9999 9.91873 11.8304C9.91873 11.5959 10.1083 11.4037 10.3505 11.4037H16.2952L15.3044 7.42348H15.3686H15.884C15.9998 7.42348 16.1043 7.42705 16.1984 7.43093L17.2679 11.7279C17.2768 11.7623 17.2801 11.7958 17.2801 11.8302V15.3645C17.2801 16.0906 16.6798 16.6838 15.9451 16.6838H1.33491C0.600215 16.6838 0 16.0906 0 15.3645V11.8302C0 11.7958 0.00405002 11.7622 0.0129602 11.7277L1.10108 7.36426Z",
      fill: "#2C3647"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.98897 7C2.9886 6.94217 2.9885 6.88478 2.9885 6.82807V2.69337C2.9885 1.71316 3.77121 0.729308 4.74526 0.729308H12.819C12.5203 0.28845 12.0176 0 11.4578 0H3.64696C2.73379 0 2 0.75675 2 1.66156V5.47821C2 6.16041 2.41132 6.74339 2.98897 7Z",
      fill: "#2C3647"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.3909 8.23316C13.2132 8.23316 13.874 7.46651 13.874 6.54987V2.68329C13.874 1.74998 13.1985 1 12.3909 1H5.35714C4.53482 1 3.87402 1.76665 3.87402 2.68329V6.54987C3.87402 7.48318 4.5495 8.23316 5.35714 8.23316H5.69488V9.56646C5.66551 9.93312 6.0473 10.1331 6.28225 9.89979L8.55831 8.24983H12.3909V8.23316Z",
      fill: "#2C3647"
    }, null, -1)
  ]))]))
}
export default { render: render }